// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"29954033","453":"8797b501"}[chunkId] + ".chunk.js";
};